/**
 * @flow
 * @relayHash fea99b675960eadf66f0e0cc8f6eed95
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type uploadAssetInput = {|
  clientMutationId?: ?string,
  propertyId: string,
  categoryId: string,
  name: string,
  imageData: string,
  hideFromList?: ?boolean,
|};
export type uploadAssetMutationVariables = {|
  input: uploadAssetInput
|};
export type uploadAssetMutationResponse = {|
  +uploadAsset: ?{|
    +asset: ?{|
      +id: string,
      +name: string,
      +fileUrl: string,
      +fileSize: number,
      +fileType: string,
      +thumbnailUrl: ?string,
      +createdAt: any,
    |}
  |}
|};
export type uploadAssetMutation = {|
  variables: uploadAssetMutationVariables,
  response: uploadAssetMutationResponse,
|};
*/


/*
mutation uploadAssetMutation(
  $input: uploadAssetInput!
) {
  uploadAsset(input: $input) {
    asset {
      id
      name
      fileUrl
      fileSize
      fileType
      thumbnailUrl
      createdAt
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "uploadAssetInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "uploadAsset",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "uploadAssetPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "asset",
        "storageKey": null,
        "args": null,
        "concreteType": "Asset",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fileUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fileSize",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fileType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "thumbnailUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "uploadAssetMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "uploadAssetMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "uploadAssetMutation",
    "id": null,
    "text": "mutation uploadAssetMutation(\n  $input: uploadAssetInput!\n) {\n  uploadAsset(input: $input) {\n    asset {\n      id\n      name\n      fileUrl\n      fileSize\n      fileType\n      thumbnailUrl\n      createdAt\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '02178d70904d89e18ed7478fb1004d6b';
module.exports = node;
